module.exports = __webpack_public_path__ + "3f30668842a39c0a77487be326cecdbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Straight Baguette.png
// module id = 796
// module chunks = 0